import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { Variables } from 'graphql-request';
import { useSelector } from 'react-redux';
import { gqlClient } from 'src/client/gql-client';
import type { AppState } from 'src/reducers';
import type { Campaign } from 'src/types';

type MutationOptions<T> = {
  mutation: string;
  variables?: Variables;
} & UseMutationOptions<T>;

export function useGqlMutation<T>(options: MutationOptions<T>) {
  const { mutation, variables: _, ...useMutationOptions } = options;

  const activeCampaign = useSelector<AppState, Campaign>(state =>
    state.globals.campaigns.active.find((c: Campaign) => c.type === 'OFFER')
  );

  const variables = {
    ...options.variables,
    campaignId: activeCampaign?.id,
  };

  const result = useMutation({
    mutationFn: () => gqlClient.request<T>(mutation, variables),
    ...useMutationOptions,
  });

  return result;
}
